







































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { DataTableState, TableContext } from '@/typings/datatable';
import DataTableWithFilters, { DataTableFilter } from '@/components/datatable-filters.vue';

import { Org, OrgsApi } from '@/api';
import { ApiUtils, FilterParam } from '@/common/ApiUtils';
import RouterLinkButton from '@/components/elements/buttons/router-link-button.vue';

@Component({
	components: {
		RouterLinkButton,
		secondaryNav,
		DataTableWithFilters,
	},
})
export default class OrganisationsList extends Vue {
	public state: DataTableState = {
		fields: [
			{ key: 'id', sortable: true },
			{ key: 'name', sortable: true },
			{ key: 'orgType', sortable: true },
			// {key: 'products.0.supplierNumber', label: 'Products'},
		],
		loading: false,
		search: null,
		sortBy: 'id',
		primaryKey: 'id',
		sortDesc: false,
		perPage: 20,
		currentPage: 1,
		totalRows: 0,
	};

	public filters: DataTableFilter[] = [
		{
			label: 'Inactive',
			field: 'inactive',
			value: false,
			type: 'checkbox',
		},
		{
			label: 'Type',
			field: 'orgType',
			value: [],
			type: 'checkboxes',
			options: [
				{ text: 'Owner', value: 'owner' },
				{ text: 'Org', value: 'org' },
				{ text: 'Partner', value: 'partner' },
			],
		},
	];

	private api: OrgsApi;

	constructor() {
		super();
		this.api = new OrgsApi();
	}

	public reload() {
		this.$root.$emit('bv::refresh::table', 'organisations-datatable');
	}

	public click(item: Org) {
		if (item.deletedAt === null) {
			this.$router.push({
				name: 'organisations.view',
				params: { orgId: item.id },
			} as any);
		}
	}

	public clickTable(item: User, newtab: boolean) {
		if (item.orgType === 'billing') {
			return;
		}
		if (newtab) {
			const routeData = this.$router.resolve({
				name: 'organisations.view',
				params: { orgId: item.id },
			} as any);
			window.open(routeData.href, '_blank');
		} else {
			this.$router.push({
				name: 'organisations.view',
				params: { orgId: item.id },
			} as any);
		}
	}

	public async dataTableProvider(ctx: TableContext) {
		let data: any = [];
		try {
			const filters: FilterParam[] = this.filters.map((filter: DataTableFilter) => {
				if (filter.field === 'inactive') {
					return { field: 'active', value: (!filter.value).toString() };
				}
				return { field: filter.field, value: filter.value };
			});
			if (this.state.search) {
				filters.push({ field: 'name', value: this.state.search });
			}
			const response = await this.api.getOrgs(
				ApiUtils.queryOptions(filters, ctx, { params: { include: 'products,children' } }),
			);
			data = response.data.data;
			// @ts-ignore
			this.state.totalRows = response.data.meta.total || 0;
		} catch (e) {
			this.state.totalRows = 0;
		}
		return data;
	}
}
